// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#account-issue{background-color:inherit;transition:background-color .5s ease}#account-issue.account-issue-background{background-color:#1f2125 !important}", ""]);
// Exports
module.exports = exports;
